var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({domProps:{"innerHTML":_vm._s(_vm.values)}},'div',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }